import { Icon, Menu } from 'antd';
import React from 'react';
import { useDownloads } from '../Downloads/containers/DownloadsDataStore';
import { useReviews } from '../Reviews/containers/ReviewsDataStore';
import TiledTitleList from '../Titles/TiledTitleList';
import { useRequests } from './containers/RequestsDataStore';
import {
	getApprovedDownloadableSku,
	getDeclinedSku,
	getDownloadedNotReviewedSku,
	getDownloadedReviewedSku,
	getPendingSku,
} from './RequestFilters';
import RequestType from './RequestType';

export default function RequestsMenu() {
	const requestsDataStore = useRequests();
	const { isLoading, requests, selectedMenuOption } = requestsDataStore.state;

	const handleClick = e => {
		requestsDataStore.setSelectedMenuOption(e.key);
	};

	const renderRequests = () => {
		const skus = getSkusToRender();
		return (
			<TiledTitleList
				skus={skus}
				isLoading={isLoading}
				titles={requests}
			/>
		);
	};

	const renderMenuItem = (items, requestType) => {
		return (
			((items && items.length > 0) || requestType.doShowIfZero) && (
				<Menu.Item key={requestType.key}>
					<Icon type={requestType.key} />
					<b>{items.length}</b> {requestType.text}
				</Menu.Item>
			)
		);
	};

	const reviewsDataStore = useReviews();
	const { reviews } = reviewsDataStore.state;

	const downloadsDataStore = useDownloads();
	const { downloads } = downloadsDataStore.state;

	const requestSkus = requests.map(item => item.sku);

	const downloadSkus = downloads
		.map(item => item.sku)
		.filter(sku => requestSkus.includes(sku));

	const reviewedSkus = reviews && reviews.map(item => item.sku);

	const getSkusToRender = () => {
		switch (selectedMenuOption) {
			case RequestType.ReadyToDownload.key:
				return getApprovedDownloadableSku(requests, downloadSkus);
			case RequestType.DownloadedNotReviewed.key:
				return getDownloadedNotReviewedSku(downloadSkus, reviewedSkus);
			case RequestType.DownloadedReviewed.key:
				return getDownloadedReviewedSku(downloadSkus, reviewedSkus);
			case RequestType.Declined.key:
				return getDeclinedSku(requests);
			case RequestType.Pending.key:
				return getPendingSku(requests);
			case RequestType.All.key:
				return requestSkus;
		}
	};

	return (
		<>
			<div>
				<Menu
					onClick={handleClick}
					selectedKeys={[selectedMenuOption]}
					mode="horizontal">
					{renderMenuItem(requests, RequestType.All)}
					{renderMenuItem(
						getApprovedDownloadableSku(requests, downloadSkus),
						RequestType.ReadyToDownload,
					)}
					{renderMenuItem(
						getDownloadedNotReviewedSku(downloadSkus, reviewedSkus),
						RequestType.DownloadedNotReviewed,
					)}
					{renderMenuItem(
						getDownloadedReviewedSku(downloadSkus, reviewedSkus),
						RequestType.DownloadedReviewed,
					)}
					{renderMenuItem(
						getDeclinedSku(requests),
						RequestType.Declined,
					)}
					{renderMenuItem(
						getPendingSku(requests),
						RequestType.Pending,
					)}
				</Menu>
			</div>
			{renderRequests()}
		</>
	);
}
